import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Box from '@mui/material/Box'
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import ErrorMessage from '../../components/FilterPanel/Filters/ErrorMessage.json'
const PREFIX = 'ChartBlankErrorTrend'
const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

const StyledBox = styled(Box)(({theme}) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    justifyContent: 'center',
    height: '300px',
    [theme.breakpoints.up('xl')]: {
      height: '400px'
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      height: '500px'
    }
  },

  [`& .${classes.icon}`]: {
    color: theme.palette.hpAccentPersianGreen,
    height: '1em',
    width: '1em'
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.hpAccentBlack
  }
}))

function ChartBlankError() {
  return (
    <StyledBox
      data-testid='timeseries-blank-chart-error'
      className={classes.root}
      aria-label={ErrorMessage.noDataMessage}
    >
      <ErrorOutlineIcon
        style={{
          width: classes.icon.width,
          height: classes.icon.height
        }}
        classes={{colorPrimary: classes.icon}}
        color='primary'
      />
      <Typography variant='h6' className={classes.loadDataBoxAction}>
        {ErrorMessage.noDataMessage}
      </Typography>
    </StyledBox>
  )
}

export default ChartBlankError
